export const SIGN_IN_PATH = '/sign-in';
export const SIGN_UP_PATH = '/sign-up';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const FORGOT_PASSWORD_SUCCESS_PATH = '/forgot-password/success';
export const RESET_PASSWORD_PATH = '/reset-password';
